import { Component } from '@angular/core';

@Component({
  selector: 'acrylic-loader',
  standalone: true,
  imports: [],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss'
})
export class LoaderComponent {

}
